import React from 'react'
import styled from 'styled-components'
import EmailField from 'Event/auth/Login/EmailField'
import Page, {
  ErrorMessage,
  StyledFormContainer,
} from 'Event/template/Lefty/Login/Page'
import {ForgotPasswordProps} from 'auth/password'
import {useLeftyTemplate} from 'Event/template/Lefty'
import {useGuestVariables} from 'Event'
import Description from 'Event/auth/ForgotPassword/Description'
import DescriptionText from 'Event/auth/ForgotPassword/Description/DescriptionText'
import SubmitButton from 'Event/auth/ForgotPassword/SubmitButton'
import Title from 'Event/template/Lefty/ForgotPassword/Title'

export default function ForgotPassword(props: ForgotPasswordProps) {
  return (
    <Page isPreview={false}>
      <StyledFormContainer>
        <Content {...props} />
      </StyledFormContainer>
    </Page>
  )
}

export function Content(props: ForgotPasswordProps) {
  const {login} = useLeftyTemplate()
  const v = useGuestVariables()

  if (props.resetLinkSent) {
    return (
      <Description
        aria-label="password reset link sent"
        Component={ForgotPasswordDescriptionText}
      >
        {v(login.passwordReset.successMessage)}
      </Description>
    )
  }

  return (
    <>
      <Title />
      <Description
        aria-label="event login description"
        Component={ForgotPasswordDescriptionText}
      >
        {v(login.passwordReset?.description)}
      </Description>
      <form onSubmit={props.onSubmit}>
        <EmailField {...props} />
        <ErrorMessage>{props.responseError?.message}</ErrorMessage>
        <SubmitButton {...props} />
      </form>
    </>
  )
}

const ForgotPasswordDescriptionText = styled(DescriptionText)`
  text-align: left;
  margin-bottom: ${(props) => props.theme.spacing[4]};
`
